import * as __au2ViewDef from './general-tab-file.html';
import { customElement, inject, EventAggregator, IDisposable } from "aurelia";
import { SelectedObjectService } from "../../../../resources/services/selected-object";
import { File } from "../../../../../../mmar-global-data-structure/models/meta/Metamodel_files.structure";
import { HelperService } from "resources/services/helper-service";
@customElement({ ...__au2ViewDef, name: "general-tab-file" })
@inject(SelectedObjectService, EventAggregator)
export class GeneralTabFile {
    private subscription: IDisposable;
    private selectedObject: File | null = null;

    constructor(
        private selectedObjectService: SelectedObjectService,
        private eventAggregator: EventAggregator,
        private helperService: HelperService,
    ) {
    }

    private file: globalThis.File | null = null;
    private imageString: string = '';

    binding() {
        this.subscription = this.eventAggregator.subscribe('SelectedObjectChanged', () => {
            // Updates whenever file changes
            if (this.selectedObjectService.type === 'File') {
                this.getFile();
            }
        });
        // For initial binding
        if (this.selectedObjectService.type === 'File') {
            this.getFile();
        }
    }

    detaching() {
        if (this.subscription) {
            this.subscription.dispose();
        }
    }

    async getFile() {
        if (this.selectedObjectService.selectedObject) {
            this.selectedObject = this.selectedObjectService.selectedObject as File;
            const fileData = this.selectedObjectService.selectedObject["data"]["data"];
            const fileName = this.selectedObjectService.selectedObject.name;
            const mimeType = this.selectedObjectService.selectedObject["type"];
            const blob = new Blob([new Uint8Array(fileData)], { type: mimeType });
            this.file = new globalThis.File([blob], fileName, { type: mimeType });
            this.getImage(); // Call getImage to set the imageString
            return;
        }
        return null;
    }

    async getImage() {
        let base64 = await this.helperService.FiletoDataUrl(this.file);
        this.imageString = `data:image/png;base64,${base64}`;
        return;
    }

    downloadFile() {
        if (this.selectedObjectService.selectedObject) {
            const url = URL.createObjectURL(this.file);
            const a = document.createElement('a');
            a.href = url;
            a.download = this.file.name || 'download';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    }

    formatFileSize(length: number): string {
        if (length >= 1073741824) {
            return (length / 1073741824).toFixed(2) + " GB";
        } else if (length >= 1048576) {
            return (length / 1048576).toFixed(2) + " MB";
        } else if (length >= 1024) {
            return (length / 1024).toFixed(2) + " KB";
        } else {
            return length + " Bytes";
        }
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = GeneralTabFile;

    // @ts-ignore
    const proto = GeneralTabFile.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }